import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

//iconos
import { Create, Add, FileCopySharp } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { Fragment } from 'react';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Abreviado', accessor: 'description_short' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function DocumentType(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [documentTypes, setDocumentTypes] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function loadDocumentTypes() {
    setDataLoading(true);
    let response = await wsGetAll('base/document-type');
    setDataLoading(false);
    if (response.success) setDocumentTypes(response.data);
  }

  useEffect(() => {
    loadDocumentTypes();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      <GridContainer>
        <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadDocumentTypes} />
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.BASE_DOCUMENT_TYPES_STORE}
                component={
                  <CardIcon color="primary">
                    <FileCopySharp style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <CardIcon
                  onClick={() => setOpen({})}
                  pointer="true"
                  color={props.themeContext.buttonColorSuccess}
                >
                  <Add />
                </CardIcon>
              </AllowedGuard>
              <h4 className={classes.cardIconTitle}>Listado de tipos de documentos {dataLoading && <LoadingSpinner />}</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                excelName="Tipos-de-documentos"
                defaultWidth={1000}
                indexRow={[0, 1, 4]}
                widthRow={[120, 100, 5]}
                columns={columns}
                data={documentTypes.map((documentType, i) => {
                  //mapeando listado para las acciones
                  return {
                    num: (
                      <div className="actions-right">
                        {i + 1}
                        <AllowedGuard permission={ConstantPermissions.BASE_DOCUMENT_TYPES_UPDATE}>
                          <Button
                            justIcon
                            round
                            simple
                            color="info"
                            onClick={() => setOpen(documentType)}
                            className="like"
                          >
                            <Create />
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_DOCUMENT_TYPES_DELETED}>
                          <ButtonDelete
                            entity="base/document-type"
                            id={documentType.id}
                            reload={loadDocumentTypes}
                          />
                        </AllowedGuard>
                      </div>
                    ),
                    code: documentType.code,
                    description_short: documentType.description_short,
                    description: documentType.description,
                    actions: ''
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
});
